<template>
	<div class="d-flex headers">
		<div class="d-flex header-left">
			<div class="title">
				<div>安徽省知识产权</div>
				<div>事业发展中心</div>
			</div>
			<img src="@/assets/img/logo.png" alt="">
		</div>
		<div class="header-center">
			<div class="title">安徽省知识产权数据管理系统</div>
			<el-cascader v-model="date" :options="dateList" @change="handleChange" v-if="$route.path != '/six'"></el-cascader>
		</div>
		<div class="header-right">
			<router-link :to="item.path" exact v-for="(item ,index) in tabList" :key="index">
				<img :src="$route.path === item.path ? item.icon : item.normal" alt="">
				<div >{{item.title}}</div>
			</router-link>
		</div>
		<router-view></router-view>
	</div>
</template>
<script>
	import "../assets/scss/header.scss";
	import {getDate} from '@/utils/api.js'
	export default {
		data() {
			return {
				date:[],
				dateList:[],
				currIndex:1,
				tabList:[
					{
						path:'/',
						title:'专利',
						normal:require('@/assets/img/patent.png'),
						icon:require('@/assets/img/patent-act.png'),
					},
					{
						path:'/two',
						title:'商标',
						normal:require('@/assets/img/brand.png'),
						icon:require('@/assets/img/brand-act.png'),
					},
					{
						path:'/three',
						title:'地理标志',
						normal:require('@/assets/img/sign.png'),
						icon:require('@/assets/img/sign-act.png'),
					},
					{
						path:'/five',
						title:'长三角',
						normal:require('@/assets/img/area.png'),
						icon:require('@/assets/img/area-act.png'),
					},
					{
						path:'/six',
						title:'转移转化',
						normal:require('@/assets/img/transfer.png'),
						icon:require('@/assets/img/transfer-act.png'),
					},
				],
			};
		},
		mounted() {
			// 获取日期
			getDate().then(res=>{
				if(res.status == 200){
					// 对年排序，从大到小
					res.data.sort((a, b) => {
					  const aValue = ~~a.year?.replace("年", "");
					  const bValue = ~~b.year?.replace("年", "");
					  return bValue - aValue;
					});
					
					if(this.$route.path == '/three'){
						// 取出数组中的年
						const map = {};
						res.data.forEach((item) => {
							map[item.year] = {
								value: item.year,
								label: item.year,
							};
						});
						this.dateList = Object.values(map);
						// 取出数组中的年
						var years = this.dateList[0].value  //默认显示第一项
						this.date = years
						var datas = {
							year:years?.replace("年", ""),
						}
						this.$emit('getTime',datas); //传值
					}else{
						const map = {};
						res.data.forEach((item) => {
							if (!map[item.year]) {
								map[item.year] = {
									value: item.year,
									label: item.year,
									children: item.month ? [{ value: item.month,label: item.month }] : [],
								};
							}else {
								item.month && map[item.year].children.push({
									value: item.month,
									label: item.month,
								});
							}
						  // 对月排序，从小到大
						  // map[item.year].children.sort((a, b) => {
						  //   const aValue = ~~a.label?.replace("月", "");
						  //   const bValue = ~~b.label?.replace("月", ""); 
						  //   return aValue - bValue;
						  // });
						});
						this.dateList = Object.values(map);
						//取数组第一项
						var year = this.dateList[0].value
						var month = this.dateList[0].children[this.dateList[0].children.length - 1].value
						this.date = [year,month] 
						var data = {
							year:year?.replace("年", ""),
							mon:month?.replace("月", "")
						}
						this.$emit('getTime',data); //传值
					}
				}
			}).catch(err=>{
				console.log(err)
			})
		},
		methods: {
			// 切换时间
			handleChange(value) {
				var data = ''
				if(this.$route.path == '/three'){
					data = {
						year:value[0]?.replace("年", ""),
					}
					
				}else{
					data = {
						year:value[0]?.replace("年", ""),
						mon:value[1]?.replace("月", "")
					}
				}
				this.$emit('getTime',data); //传值
			}
		}
	}
</script>
<style>
/* 输入框 */
.el-input__inner {
	height: 36px !important;
	line-height: 36px !important;
	background: #262C33;
	color: #fff;
	border: none;
}
.el-input__icon {
	line-height: 36px;
}
/* 三角 */
.el-popper[x-placement^=bottom] .popper__arrow {
	border-bottom-color: #2681FF;
}

.el-popper[x-placement^=bottom] .popper__arrow::after {
	border-bottom-color: #2681FF;
}
/* 下拉 */
.el-cascader__dropdown{
	background: #262C33 !important;
	border: 1px solid #2681FF !important;
}
.el-cascader-menu{
	min-width:130px !important;
	color:#fff !important;
	border-right:1px solid #2681FF !important;
}
.el-cascader-menu:last-child{
	border-right:0 !important;
}
.el-cascader-node:not(.is-disabled):focus, .el-cascader-node:not(.is-disabled):hover{
	background:#2681FF !important;
}
.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{
	color: #fff !important;
}
	
</style>
